import React from 'react';
import { Button, Collapse, Dropdown, Table } from 'react-bootstrap';
import { faPen, faCircleCheck, faThumbsUp, faEllipsis } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FilterBadge } from '../../School/components/StudentImmunizationStatusFilters';
import ShowExemptions from './ShowExemptions';

const BADGE_CONFIG = {
  required: {
    backgroundColor: "#E5F3FD",
    color: "#0041C2",
    icon: faCircleCheck,
    label: "Required"
  },
  recommended: {
    backgroundColor: "#F3F4F6",
    color: "#4B5563",
    icon: faThumbsUp,
    label: "Recommended"
  },
};

const RequiredRecommendedBadge = ({ isRequired }) => {
  const config = isRequired ? BADGE_CONFIG.required : BADGE_CONFIG.recommended;
  return (
    <div className="my-auto ms-2">
      <div
        className="p-1 body-small-medium"
        style={{
          backgroundColor: config.backgroundColor,
          borderRadius: "4px",
          color: config.color,
        }}
      >
        <FontAwesomeIcon className="me-1" icon={config.icon} />
        {config.label}
      </div>
    </div>
  );
};

const VaccineGroup = ({
  exemptionCategories,
  exemptionOptions,
  exemptionTypes,
  handleVaccineGroupToggle,
  immunizationRecordStatus,
  isRequired,
  openEditDoseModal,
  openCreateDoseModal,
  pendingStatuses,
  record,
  show,
  testGroup,
  testGroupUser,
}) => {
  const sourceLabel = (source) => {
    if (source === "upload") {
      return "Admin";
    } else if (source) {
      return source.toUpperCase();
    } else {
      return "n/a";
    };
  };

  const ageGivenLabel = (ageGiven) => {
    const { year, month } = ageGiven;
    if (!!year) {
      return year + " years";
    } else if (!!month) {
      return month + " months";
    } else {
      return "n/a";
    };
  };

  const setBadge = (record) => {
    if (!isRequired) {
      return <FilterBadge
        label={`${record.doses.length} doses`}
        value={"recommended"}
      />
    } else if (["medically_exempt", "non_medically_exempt"].includes(immunizationRecordStatus)) {
      return <ShowExemptions
        categoryOptions={exemptionCategories}
        conditionName={record.name}
        conditionOptions={exemptionOptions}
        exemptions={record.exemptions}
        immunizationRecordStatus={immunizationRecordStatus}
        testGroup={testGroup}
        testGroupUser={testGroupUser}
        typeOptions={exemptionTypes}
      />
    } else {
      const nOfTotalDosesLabel = `${record.doses.length} of ${record.num_doses} doses`;
      return (
        <FilterBadge
          label={nOfTotalDosesLabel}
          value={immunizationRecordStatus}
        />
      )
    };
  };

  return (
    <div className="my-2">
      <div
        className="py-2 d-flex justify-content-between pointer"
        onClick={(e) => {
          e.preventDefault();
          handleVaccineGroupToggle(record.name)
        }}
      >
        <div className="d-flex my-auto">
          <div className="me-2">
            <FontAwesomeIcon
              icon={['fa-solid', 'angle-down']}
              className={show ? 'rotate-180' : ''}
              style={{
                transition: 'transform 0.2s ease-in-out',
                transform: show ? 'rotate(180deg)' : 'rotate(0deg)'
              }}
            />
          </div>
          <div className="body-large-18-semibold">{record.name}</div>
          <RequiredRecommendedBadge isRequired={isRequired} />
          {record.next_dose_due && !pendingStatuses.includes(immunizationRecordStatus) && (
            <div className="mt-1 ms-2 body-small-medium">{"Next due: "}{record.next_dose_due}</div>
          )}
        </div>
        {setBadge(record)}
      </div>
      <Collapse in={show} className="mt-3">
        <div>
          <Table className="carded-table" responsive style={{ tableLayout: "fixed" }}>
            <thead>
              <tr className="vaccine-group-header">
                <th className="vaccine-group-header-first-header-column">Dose #</th>
                <th>Date</th>
                <th>Age given</th>
                <th>Vaccine</th>
                <th>Source</th>
                <th className="vaccine-group-header-last-header-column"></th>
              </tr>
            </thead>
            <tbody>
              {record.doses.map((dose, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{dose.date}</td>
                  <td>{ageGivenLabel(dose.age_given)}</td>
                  <td>{dose.name}</td>
                  <td>{sourceLabel(dose.source)}</td>
                  <td>
                    {dose.source === "upload" && (
                      <span className="ms-3">
                        <div
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          className="pointer p-2 body-large-16-medium"
                          style={{ width: "40px" }}
                        >
                          <FontAwesomeIcon icon={faEllipsis} className="text-dark" />
                        </div>
                        <ul className="dropdown-menu dropdown-menu-end">
                          <Dropdown.Item onClick={() => openEditDoseModal(dose)}>
                            <FontAwesomeIcon icon={faPen} className="me-1" />
                            Edit dose
                          </Dropdown.Item>
                        </ul>
                      </span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Button
            className="mb-3"
            onClick={(e) => {
              e.stopPropagation();
              openCreateDoseModal(record);
            }}
            size="sm"
          >
            Add dose
          </Button>
        </div>
      </Collapse>
    </div>
  );
};

export default VaccineGroup;
